import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  Body,
  Caption1,
  Title1,
  Title3,
  Callout,
} from "../../../../components/Typography";
import Select from "../../../../components/Select";
import LocationPickupCard from "./LocationPickupCard";
import LocationCustomFormatLabel from "../../OrderSettingModal/components/LocationCustomLabel";
import { PICKUP, DELIVERY, DROPOFF } from "../../orderSettingTypes";
import OrderFutureSchedule from "../../../ParentChildRefactor/components/OrderFutureSchedule";
import appConfigFile from "../../../../../app-config";
import ConfirmationDialog from "../../../Menu/components/GlobalSearchMenu/components/ConfirmationDialog";
import { navigate } from "gatsby";

const MainDiv = styled.div`
  background: white;
  padding: 19px 36px 32px 36px;
  margin: 0;
  border-bottom: solid 3px #ebebeb;
  margin-top: 5px;
  border-start-start-radius: 5px;

  @media (max-width: 786px) {
    padding: 16px;
    align-items: center;
  }

  @media (min-width: 800px) {
    min-width: 750px;
  }

  @media (min-width: 1080px) {
    min-width: 960px;
  }

  @media (min-width: 960px) {
    min-width: 930px;
  }
`;
const LocationsWrapper = styled.div`
  display: grid;
  overflow-y: auto;
  max-height: 450px;
  padding: 19px 36px 0 36px;
  margin-bottom: 5px;
  border-end-end-radius: 5px;
  @media (max-width: 786px) {
    padding: 16px 16px 32px 16px;
    align-items: center;
    width: 100%;
  }
`;
const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 2fr;
  width: 100%;
  @media (max-width: 786px) {
    display: block;
  }
`;
const Title = styled(Title1)`
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 5px;
`;
const SelectSectionWrapper = styled.div`
  margin: 0 16px 0 0;
  @media (max-width: 786px) {
    display: block;
    margin: 9px 0;
  }
`;

const StoresWrapper = styled.div`
  display: grid;
`;

const AddNewButton = styled(Caption1)`
  cursor: pointer;
  color: ${(props) => props.color || props.theme.clickableTextColor};

  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
  }
`;
const Stores = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0px 46px;
  padding: 0 5px;
  animation: fadeIn 0.5s ease-in-out;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const CalloutWrapper = styled(Callout)`
  text-align: right;
  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
  }
`;

const MarketplacePickup = ({
  confirmPickUpDetails,
  interPickUpDetails,
  interOrderType,
  updateInterOrderType,
  locations,
  updateInterPickUpDetails,
  parentLocation,
  setParentLocation,
  getChildLocations,
  childLocations,
  isAuthenticated,
  profileSettingsReducer,
  setPickUpTimeFormIsVisible,
  cartReducer,
  updateOrderSettingModalIsVisible,
  resetInterSelectedDateTime,
  isDeepLink,
  isParentDeepLink,
  deepLinkParameters,
  setIsParentStoreDeepLink,
}) => {
  const { appSource } = appConfigFile;
  const { email } = profileSettingsReducer;
  const { products, combos } = cartReducer;

  const [isCartMessageVisible, setIsCartMessageVisible] = useState(false);
  const [selectedParent, setSelectedParent] = useState(null);
  const [filteredChildLocations, setFilteredChildLocations] = useState(null);

  useEffect(() => {
    if (deepLinkParameters?.parentId && locations && locations.length > 0) {
      const parentStore = locations.filter(
        (addr) => addr.id === parseInt(deepLinkParameters.parentId)
      );
      if (parentStore.length > 0 && !isParentDeepLink) {
        setParentLocation(parentStore[0]);
        setIsParentStoreDeepLink(true);
      }
    }
  }, [locations]);

  useEffect(() => {
    if (parentLocation && interOrderType) {
      getChildLocations(parentLocation.id);

      const strParentLocation = JSON.stringify(parentLocation);

      if (isAuthenticated && !appConfigFile.isDeepLinkClient) {
        localStorage.setItem(`${appSource}-${email}`, strParentLocation);
      } else {
        localStorage.setItem(`${appSource}-guest`, strParentLocation);
      }
    }
  }, [parentLocation, interOrderType]);

  useEffect(() => {
    const cachedParentLocation = isAuthenticated
      ? localStorage.getItem(`${appSource}-${email}`)
      : localStorage.getItem(`${appSource}-guest`);

    if (cachedParentLocation && !appConfigFile.isDeepLinkClient) {
      const parsedLocation = JSON.parse(cachedParentLocation);
      setParentLocation(parsedLocation);
    }
  }, []);

  useEffect(() => {
    let locations = null;
    if (childLocations && childLocations.length > 0) {
      locations = childLocations.filter((childLocation) =>
        childLocation.accepted_order_types.includes(PICKUP)
      );
    }

    if (locations && locations.length > 0) {
      setFilteredChildLocations(locations);
    } else {
      setFilteredChildLocations(null);
    }
  }, [childLocations]);

  const onLocationChange = (location) => {
    // const isCartEmpty =
    //   products && combos && products.length === 0 && combos.length === 0;
    // if (parentLocation && location && !isCartEmpty) {
    //   if (parentLocation.id !== location.id) {
    //     setSelectedParent(location);
    //     setIsCartMessageVisible(true);
    //   } else {
    //     setParentLocation(location);
    //   }
    // } else {
    setParentLocation(location);
  };

  const onConfirmationResponse = () => {
    if (selectedParent) {
      setIsCartMessageVisible(false);
      setParentLocation(selectedParent);
    }
  };

  const filteredLocations = locations.length
    ? locations.filter(
        (location) => location.accepted_order_types[0] !== "scan_and_go"
      )
    : [];

  const onOrderTypeChange = (interOrderType) => {
    if (interOrderType === PICKUP) {
      updateInterOrderType(interOrderType);
    } else if (interOrderType === DELIVERY) {
      updateInterOrderType(interOrderType);
    } else if (interOrderType === DROPOFF) {
      updateInterOrderType(interOrderType);
    }
  };

  const isCurrentStore = (store) => {
    if (interPickUpDetails && store) {
      if (interPickUpDetails.id === store.id) {
        return true;
      }
    }

    return false;
  };

  const availableOrderMethods = parentLocation
    ? parentLocation.accepted_order_types
    : [];

  return (
    <>
      <MainDiv>
        <Title>{"Order Method"}</Title>
        <SectionWrapper>
          <SelectSectionWrapper>
            <Select
              value={parentLocation}
              options={locations}
              getOptionLabel={(location) => location.name}
              getOptionValue={(location) => location}
              placeholder="Select a Location ..."
              maxMenuHeight={200}
              isLocation={true}
              onChange={(location) => onLocationChange(location)}
              isDisabled={isParentDeepLink}
              disabled={isParentDeepLink}
              formatOptionLabel={(location) => (
                <LocationCustomFormatLabel
                  location={location}
                  interPickUpDetails={interPickUpDetails}
                />
              )}
            />
            {appConfigFile.appSource !== "feastify" ? (
              <AddNewButton
                to="/locations"
                onClick={() => {
                  navigate("/locations");
                  updateOrderSettingModalIsVisible(false);
                }}
              >
                <CalloutWrapper style={{ marginTop: "5px", marginLeft: "5px" }}>
                  View Map
                </CalloutWrapper>
              </AddNewButton>
            ) : null}
          </SelectSectionWrapper>
          <SelectSectionWrapper>
            <Select
              options={availableOrderMethods.map((value) => ({
                value: value,
                name: value.charAt(0).toUpperCase() + value.slice(1),
              }))}
              placeholder="Select Order Type"
              getOptionLabel={(option) =>
                option.name ? option.name.replaceAll("_", "-") : null
              }
              getOptionValue={(option) => (option.value ? option.value : null)}
              onChange={(interOrderType) => onOrderTypeChange(interOrderType)}
              value={
                interOrderType
                  ? {
                      value: interOrderType,
                      name:
                        interOrderType.charAt(0).toUpperCase() +
                        interOrderType.slice(1),
                    }
                  : null
              }
            />
          </SelectSectionWrapper>
        </SectionWrapper>
      </MainDiv>
      <LocationsWrapper>
        {interPickUpDetails && (
          <>
            <StoresWrapper>
              <Title1 style={{ fontWeight: "600", marginBottom: "24px" }}>
                {"Current Store"}
              </Title1>
              <Stores>
                <LocationPickupCard
                  isCurrentStore
                  location={interPickUpDetails}
                  updateInterPickUpDetails={updateInterPickUpDetails}
                  confirmPickUpDetails={confirmPickUpDetails}
                  setPickUpTimeFormIsVisible={setPickUpTimeFormIsVisible}
                  resetInterSelectedDateTime={resetInterSelectedDateTime}
                />
              </Stores>
            </StoresWrapper>
          </>
        )}
        {!parentLocation && !childLocations && (
          <>
            <StoresWrapper>
              <Title1 style={{ fontWeight: "600", marginBottom: "24px" }}>
                Select Stores
              </Title1>
              <Body style={{ fontWeight: "bold", marginBottom: "24px" }}>
                Select a location to browse stores
              </Body>
            </StoresWrapper>
          </>
        )}
        {filteredChildLocations && filteredChildLocations.length !== 0 ? (
          <>
            <StoresWrapper>
              <Title1 style={{ fontWeight: "600", marginBottom: "24px" }}>
                {interPickUpDetails ? "Other Stores" : "Select Store"}
              </Title1>
              <Stores>
                {filteredChildLocations.map((location) => (
                  <>
                    {location && !isCurrentStore(location) && (
                      <LocationPickupCard
                        location={location}
                        updateInterPickUpDetails={updateInterPickUpDetails}
                        confirmPickUpDetails={confirmPickUpDetails}
                        setPickUpTimeFormIsVisible={setPickUpTimeFormIsVisible}
                        resetInterSelectedDateTime={resetInterSelectedDateTime}
                      />
                    )}
                  </>
                ))}
              </Stores>
            </StoresWrapper>
          </>
        ) : (
          <>
            <Body style={{ color: "#737a87", marginTop: "25px" }}>
              Couldn’t find what you’re looking for? Try Delivery instead.
            </Body>
          </>
        )}
      </LocationsWrapper>
      <ConfirmationDialog
        open={isCartMessageVisible && isAuthenticated}
        close={() => setIsCartMessageVisible(false)}
        location={interPickUpDetails}
        cart={cartReducer}
        onGoToMenuClick={() => onConfirmationResponse()}
      />
    </>
  );
};

export default MarketplacePickup;
